import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('sale_order_items_log')
export class SaleOrderItemsLog {

  @PrimaryGeneratedColumn("increment", { name: 'sale_order_item_log_id' })
  saleOrderItemLogId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;
  @Column("int", {
    nullable: false,
    name: "sale_order_item_id"
  })
  saleOrderItemId: number;
  @Column("int", {
    nullable: false,
    name: "item_id"
  })
  itemId: number;
  @Column("int", {
    nullable: false,
    name: "min_grade_id"
  })
  minGrade: number;
  @Column("int", {
    nullable: false,
    name: "max_grade_id"
  })
  maxGrade: number;
  @Column("int", {
    nullable: false,
    name: "food_type_id"
  })
  foodTypeId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_one_id"
  })
  valueAdditionOneId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_two_id"
  })
  valueAdditionTwoId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_three_id"
  })
  valueAdditionThreeId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_four_id"
  })
  valueAdditionFourId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_five_id"
  })
  valueAdditionFiveId: number;

  @Column("int", {
    nullable: false,
    name: "varient_id"
  })
  varientId: number;

  @Column("int", {
    nullable: true,
    name: "skewer_size_item_id"
  })
  skewerSizeItemId: number;

  @Column("int", {
    nullable: true,
    name: "inner_bag_size_id"
  })
  innerBagSizeId: number;

  @Column("int", {
    nullable: false,
    name: "cases"
  })
  cases: number;

  @Column({
    type: 'decimal', precision: 10, scale: 2,
    nullable: false,
    name: "net_amount"
  })
  netAmount: number;

  @Column({
    type: 'decimal', precision: 10, scale: 2,
    nullable: false,
    name: "unitPrice"
  })
  unitPrice: number;
  @Column("int", {
    nullable: false,
    name: "requiredCount"
  })
  requiredCount: number;

  @Column("int", {
    nullable: false,
    name: "pouches"
  })
  pouches: number;

  @Column("int", {
    nullable: false,
    name: "inner_bags"
  })
  innerBags: number

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "shrimp_weight"
  })
  shrimpWeight: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "pouch_weight"
  })
  pouchWeight: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "case_weight"
  })
  caseWeight: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: true,
    name: "gross_weight_per_kg"
  })
  grossWeightPerKg: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: true,
    name: "total_gross_weight"
  })
  totalGrossWeight: number;

  @Column("int", {
    nullable: false,
    name: "categry_id"
  })
  categoryId: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "net_weight"
  })
  netWeight: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    default: 0,
    name: "dispatched_qty"
  })
  dispatchedQty: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    default: 0,
    name: "invoiced_qty"
  })
  invoicedQty: number;


  @Column("decimal", {
    nullable: false,
    name: "inv_amount",
    default:0,
  })
  invoiceAmount: number;

  @Column({
    type: 'decimal', precision: 10, scale: 2,
    nullable: false,
    default: 0,
    name: "revised_price"
  })
  revisedUnitPrice: number;
  @Column("int", {
    nullable: true,
    name: "tax_id",
  })
  taxId: number;

  @Column("int", {
    nullable: false,
    name: "uom_id"
  })
  uomId: number;
  @Column("int", {
    nullable: false,
    name: "pack_style_id"
  })
  packStyleId: number;


  @Column("int", {
    nullable: false,
    name: "min_glaze"
  })
  minGlaze: number;

  @Column("int", {
    nullable: false,
    name: "max_glaze"
  })
  MaxGlaze: number;

  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "soaking_time"
  })
  soakingTime: string;


  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "soaking_style"
  })
  soakingStyle: string;

  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "style_weighment"
  })
  styleWeighment: string;

  @Column({
    type: 'decimal', precision: 5, scale: 2,
    nullable: false,
    default: 70.5,
    name: 'hl_per',
  })
  hlPercentage: number;



  @Column({
    type: 'decimal', precision: 5, scale: 2,
    nullable: false,
    // default:105,
    name: 'final_percentage',
  })
  finalPercentage: number;

  @Column("varchar", {
    length:20,
    nullable: true,
    name: "category"
  })
  category: string;



  @Column("int", {
    nullable: false,
    name: "brand_id"
  })
  brandId: number;

  @Column("int", {
    nullable: false,
    name: "master_brand_id"
  })
  masterBrandId: number;
  @Column("int", {
    nullable: true,
    name: "reported_cases"
  })
  reportedCases: number;
  @Column("datetime", {
    nullable: true,
    name: "reported_date"
  })
  reportedDate: Date;
  @Column("int", {
    nullable: true,
    default: 0,
    name: "invoicedCases"
  })
  invoicedCases: number;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;


}
